<template>
  <div class="bindaccount">
    <div class="content">
      <div class="top-error-msg">
          <p class="top-error-msg-print">{{ $t('sorryNotFound1') }}{{ this.urlType }}{{ $t('sorryNotFound2') }}</p>
      </div>
      <div class="bind-error-top-container" v-if="bindErrorMessageTop">
        <p class="bind-error-top">{{ bindErrorMessageTop }}</p>
      </div>
      <div class="info">
        <div v-if="!forgetPasswordShow && !verificationCodeShow && !newPasswordShow && !resetSuccessShow" class="info_left">
          <div class="operating">
            <p class="top-titles">{{ $t('bindNewAccount') }}{{ this.urlType }}</p>
            <!-- <p class="save_time" style="font-weight: 600">
              {{ $t("save_time_later1") }}
            </p> -->
            <!-- <p class="save_time">{{ $t("save_time_later2") }}</p> -->
            <p class="save_time">{{ $t('bindNewInfo1') }}{{ this.urlType }}{{ $t('bindNewInfo2') }}</p>

            <p v-if="registerErrorMessage || this.errors.server" class="server-error-msg">
              <b>{{ this.errors.server }}</b>
            </p>
            <div class="input_box input_box_top">
              <span>{{ $t('newEmail') }}</span>
              <el-input
                :class="[this.errors.email ? 'el-input-error' : 'el-input']"
                v-model="formRegister.email"
                :placeholder="$t('enter_email_address')"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.email }}</span>
            </div>
            <div class="input_box input_box_top">
              <span>{{ $t('password') }}</span>
              <el-input
                :class="[this.errors.password ? 'el-input-error' : 'el-input']"
                v-model="formRegister.password"
                type="password"
                :placeholder="$t('enter_password')"
              ></el-input>
              <span class="input_error_msg">{{ this.errors.password }}</span>
            </div>
            <div class="input_box">
              <span>{{ $t('reenter_password') }}</span>
              <el-input
                :class="[this.errors.password ? 'el-input-error' : 'el-input']"
                v-model="reenterPassword"
                type="password"
                :placeholder="$t('reenter_password')"
              ></el-input>
            </div>
            <button @click="register(formRegister)" class="create_btn">
              {{ $t('createBind') }}
            </button>
          </div>
        </div>

        <div v-if="!forgetPasswordShow && !verificationCodeShow && !newPasswordShow && !resetSuccessShow" class="info_right">
          <div class="operating">
            <p class="top-titles">{{ $t('bindExistingAccount') }}{{ this.urlType }}</p>
            <p class="save_time">{{ $t('bindExistingInfo1') }}{{ this.urlType }}{{ $t('bindExistingInfo2') }}</p>
            <p
              v-if="loginErrorMessageBind"
              style="padding-bottom: 20px; color: red"
            >
              <b>{{ loginErrorMessageBind }}</b>
            </p>
            <!-- <p v-if="newPasswordResetMessage" style="padding:10px; border: 1px, solid rgb(3, 211, 252)">
              <h3>{{ newPasswordResetMessage }}</h3>
            </p> -->
            <div class="input_box input_box_top">
              <span>{{ $t('email') }}</span>
              <el-input
                :class="[(this.loginErrorEmail && !formLabelAlign.username) ? 'el-input-error' : 'el-input']"
                v-model="formLabelAlign.username"
                :placeholder="[this.loginErrorEmail ? this.loginErrorEmail : $t('enter_email_address')]"
              ></el-input>
            </div>
            <div class="input_box">
              <span>{{ $t('password') }}</span>
              <el-input
                :class="[
                  (this.loginErrorPassword && !formLabelAlign.password) ? 'el-input-error' : 'el-input',
                ]"
                v-model="formLabelAlign.password"
                type="password"
                :placeholder="[this.loginErrorPassword ? this.loginErrorPassword : $t('enter_password')]"
              ></el-input>
              <!-- <span class="forgot-pw" @click="onEnableForgotPassword">{{
                $t("forgotPassword")
              }}</span> -->
            </div>
            <button @click="Login(formLabelAlign)">{{ $t('loginBind') }}</button>
          </div>
        </div>

        <!-- <div v-if="forgetPasswordShow || verificationCodeShow || newPasswordShow || resetSuccessShow" class="info_right_forgot">
          <p class="top-titles">{{ $t("reset_password") }}</p>
          <div v-if="forgetPasswordShow" class="operating">
            <p class="forgot-text">{{ $t("reset_password_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorEmail }}</b>
            </p>
            <div class="input_box">
              <span>{{ $t("email") }}</span>
              <el-input
                :class="[(this.resetErrorEmail) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.email"
                :placeholder="$t('enter_email_address')"
              ></el-input>
            </div>
            <button @click="onSendResetEmail">{{ $t("send_code") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div> -->

          <!-- <div v-if="verificationCodeShow" class="operating">
            <p class="forgot-text">{{ $t("verification_code_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorCode }}</b>
            </p>
            <div class="input_box">
              <span>{{ $t("verification_code") }}</span>
              <el-input
                :class="[(this.resetErrorCode) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.verificationCode"
                :placeholder="$t('enter_code')"
              ></el-input>
            </div>
            <button @click="onSendVerificationCode">{{ $t("confirm") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div> -->

          <!-- <div v-if="newPasswordShow" class="operating">
            <p class="forgot-text">{{ $t("new_password_text") }}</p>
            <p v-if="true" class="server-error-msg">
              <b>{{ this.resetErrorPassword }}</b>
            </p>
            <div class="input_box input_box_top">
              <span>{{ $t("new_password") }}</span>
              <el-input
                :class="[(this.resetErrorPassword) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.newPassword"
                :placeholder="$t('enter_password')"
                type="password"
              ></el-input>
            </div>
             <div class="input_box">
              <span>{{ $t("reenter_password") }}</span>
              <el-input
                :class="[(this.resetErrorPassword) ? 'el-input-error' : 'el-input']"
                v-model="resetInfo.newPasswordReenter"
                :placeholder="$t('reenter_password')"
                type="password"
              ></el-input>
            </div>
            <button @click="onSendNewPassword">{{ $t("confirm") }}</button>
            <button class="bottom-button" @click="onCancelForgetPassword">{{ $t("cancel") }}</button>
          </div> -->

          <!-- <div v-if="resetSuccessShow" class="operating">
            <p class="forgot-text">{{ $t("reset_success_1") }}</p>
            <p class="forgot-text">{{ $t("reset_success_2") }}</p>
            <button @click="onFinishReset">{{ $t("logIn") }}</button>
          </div> -->


        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Router from "../router";
import { isUserAuthenticated } from "../store/modules/cart";
import {uni} from '../mixin'

export default {
  name: "bindaccount",
  mixins: [uni],
  data() {
    return {
      urlCode: '',
      urlType: '',
      unionid: '',
      urlUser: '',
        // create start
      errors: {
        email: "",
        password: "",
        server: "",
      },
      formRegister: {
        FirstName: "guest",
        LastName: "guest",
        email: "",
        password: "",
        username: "",
      },
      reenterPassword: "",
    //   create end

      forgetPasswordShow: false,
      verificationCodeShow: false,
      newPasswordShow: false,
      resetSuccessShow: false,
      resetInfo: {
        email: "",
        verificationCode: "",
        newPassword: "",
        newPasswordReenter: "",
        token: "",
      },
      resetErrorEmail: "",
      resetErrorCode: "",
      resetErrorPassword: "",

      loginErrorEmail: "",
      loginErrorPassword: "",
      labelPosition: "top",
      formLabelAlign: {
        username: "",
        password: "",
      },
      email: "",
      login: true, //true showlogin; false forget password
      showModal: false,
      showChangeToNewPassword: false,
      newPasswordResetMessage: "",
      verification: "",
      tempToken: "",
      newpassword: "",
      couldNotFindEmail: false,
      verificationCodeFail: false,
    };
  },
  methods: {
    ...mapActions("auth", [
      "LoginRequest",
      "resetEmail",
      "sentVerificationCode",
      "resetPassword",
      "registerRequest",
      "checkUsername",
      "checkEmail",
      "LoginBindRequest",
    ]),
    ...mapMutations("auth", ["updateErrorMessage"]),
    ...mapMutations('navbar', ['toggleLoginModalVisibility']),

    // create start
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    checkForm(form) {
      this.errors = [];

      if (!form.password || !this.reenterPassword) {
        this.errors.password = this.$t("passwordRequired");
      } else if (form.password !== this.reenterPassword) {
        this.errors.password = this.$t("passwordNotMatch");
      }
      // if (form.password.length < 8) {
      //   this.errors.push(this.$t("passwordLengthRequired"));
      // }
      // if (form.username.length < 5) {
      //   this.errors.push(this.$t("usernameLengthRequired"));
      // }
      if (form.email) {
        this.checkUsername({ username: form.username });
      }
      if (!form.email) {
        this.errors.email = this.$t("emailRequired");
      } else if (!this.validEmail(form.email)) {
        this.errors.email = this.$t("emailValidRequired");
      } else {
        this.checkEmail({ email: form.email });
      }
    },
    register(form) {
      form.username = this.formRegister.email;
      this.checkForm(form);
      if (!this.errors.email && !this.errors.password && !this.errors.server) {
        this.registerRequest(form)
          .then((res) => {
            const {urlCode, unionid, urlUser, urlType} = this
            this.LoginBindRequest({
              username: form.username,
              password: form.password,
              code: urlCode,
              type: urlType,
              unionid: unionid,
              user: urlUser,
            });
          })
          .catch((err) => {
            this.errors = [];
            // this.errors.push(this.$t("errorCreateAccount"));
            this.errors.server = this.$t("errorCreateAccount");
          });
      }
    },
    resetCreateForm() {
      this.errors = {
        email: "",
        password: "",
        server: "",
      };
      this.formRegister = {
        FirstName: "guest",
        LastName: "guest",
        email: "",
        password: "",
        username: "",
      };
      this.reenterPassword = "";
    },
// create end


    ForgotPassword() {
      (this.newPasswordResetMessage = ""),
        // this.loginErrorMessageBind = '',
        (this.login = !this.login);
    },
    Login(form) {
      this.loginErrorEmail = "";
      this.loginErrorPassword = "";
      this.updateErrorMessage(null);
      if (!form.username) {
        this.loginErrorEmail = this.$t("emailRequired");
      }
      if (!form.password) {
        this.loginErrorPassword = this.$t("passwordRequired");
      }
      if (form && form.username && form.password) {
        form.code = this.urlCode;
        form.type = this.urlType;
        form.unionid = this.unionid;
        form.user = this.urlUser;
        this.LoginBindRequest(form);
      }
    },
    resetPasswordRequest(password) {
      this.resetPassword({ new_password: password, token: this.tempToken })
        .then((res) => {
          Object.assign(this.$data, this.$options.data.call(this));
          this.newPasswordResetMessage =
            "You have successfully reset your password";
        })
        .catch((err) => {
          alert(
            "err resetting the password, please contact for more information"
          );
        });
    },
    sendVerificationCode(code) {
      this.verificationCodeFail = false;
      if (code.length < 6) {
        return;
      }
      this.sentVerificationCode({ code, token: this.tempToken })
        .then((res) => {
          this.showModal = false;
          this.tempToken = res.data;
          this.showChangeToNewPassword = true;
        })
        .catch((err) => {
          console.log("catching error sending verification code", err);
          this.verificationCodeFail = true;
        });
    },
    cancelEnteringVerificationCode() {
      this.showModal = false;
    },
    goToRegister() {
      this.$router.push("/register");
    },
    resetLoginForm() {
      this.loginErrorEmail = "";
      this.loginErrorPassword = "";
      // this.formLabelAlign.username = "";
      this.formLabelAlign.password = "";
    },
    resetForgetPassword() {
      this.forgetPasswordShow = false,
      this.verificationCodeShow = false,
      this.newPasswordShow = false,
      this.resetSuccessShow = false,
      this.resetInfo = {
        email: "",
        verificationCode: "",
        newPassword: "",
        newPasswordReenter: "",
        token: "",
      };
      this.resetErrorEmail = "";
      this.resetErrorCode = "";
      this.resetErrorPassword = "";
    },
    onEnableForgotPassword() {
      this.forgetPasswordShow = true;
      this.resetLoginForm();
    },
    onCancelForgetPassword() {
      this.resetForgetPassword();
    },
    onSendResetEmail() {
      if (!this.resetInfo.email) {
         this.resetErrorEmail = this.$t("emailRequired");
      } else {
        // this.couldNotFindEmail = false;
        this.resetEmail(this.resetInfo.email)
          .then((res) => {
            this.resetInfo.token = res.data;
            this.forgetPasswordShow = false;
            this.verificationCodeShow = true;
            // this.tempToken = res.data;
            // this.showModal = true;
          })
          .catch((err) => {
            this.resetInfo.token = "";
            this.resetErrorEmail = err.response.data;
            // this.resetErrorEmail = this.$t("emailNotFound");
            // this.couldNotFindEmail = true;
          });
      }
    },
    onSendVerificationCode() {
      if (!this.resetInfo.verificationCode) {
         this.resetErrorCode = this.$t("codeRequired");
      } else {
        //  this.verificationCodeFail = false;
        // if (code.length < 6) {
        //   return;
        // }
        this.sentVerificationCode({ code: this.resetInfo.verificationCode, token: this.resetInfo.token })
          .then((res) => {
            this.resetInfo.token = res.data;
            this.verificationCodeShow = false;
            this.newPasswordShow = true;
            // this.showModal = false;
            // this.tempToken = res.data;
            // this.showChangeToNewPassword = true;
          })
          .catch((err) => {
            // this.resetErrorCode = err.response.data;
            this.resetErrorCode = this.$t("codeIncorrect");
            // this.verificationCodeFail = true;
          });
      }
    },
    onSendNewPassword() {
      if (!this.resetInfo.newPassword || !this.resetInfo.newPasswordReenter) {
        this.resetErrorPassword = this.$t("passwordRequired");
      } else if (this.resetInfo.newPassword !== this.resetInfo.newPasswordReenter) {
        this.resetErrorPassword = this.$t("passwordNotMatch");
      } else {
        this.resetPassword({ new_password: this.resetInfo.newPassword, token: this.resetInfo.token, code: this.resetInfo.verificationCode })
          .then((res) => {
            // Object.assign(this.$data, this.$options.data.call(this));
            this.newPasswordShow = false;
            this.resetSuccessShow = true;
            // this.newPasswordResetMessage = "You have successfully reset your password";
          })
          .catch((err) => {
            console.log("reset password error: ", err.response);
            this.resetErrorPassword = this.$t("server_error");
          });
      }
    },
    onFinishReset() {
      this.resetForgetPassword();
    },
    logInWithMedia(type) {},
    initPageData() {
      const {code, unionid, user, type} = this.$route.query
      this.urlCode = code;
      this.unionid = unionid;
      this.urlUser = user;
      this.urlType = type;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated()) {
      this.$store.dispatch("cart/getCart");
      this.$store.dispatch("auth/fetchCustomerInformation");
    } else {
      // this.$store.dispatch("cart/fetchCartProducts");
      // this.$store.dispatch("auth/fetchCustomerInformation");
    }
    next();
  },
  mounted() {
    this.initPageData()
    // this.urlType = "Google";
  },
  activated() {
    // APP隐藏登录弹窗
    this.isApp && this.toggleLoginModalVisibility(false)
  },
  watch: {
    $route(to, from) {
      this.resetLoginForm();
      this.resetForgetPassword();

      this.initPageData()
      // this.urlType = "Google";
    },
  },
  computed: {
    ...mapState({
      loginErrorMessageBind: (state) => state.auth.loginErrorMessageBind,
      registerErrorMessage: (state) => state.auth.registerErrorMessage,
      bindErrorMessageTop: (state) => state.auth.bindErrorMessageTop,
    })
  },
};
</script>
​
​
<style scoped lang="less">
@import "../assets/css/public";
@import "../assets/css/bindAccount";
</style>



// WEBPACK FOOTER //
// src/view/bindAccount.vue